import React from "react";
import { XMarkIcon, ExclamationTriangleIcon, ArrowPathIcon } from "@heroicons/react/24/outline";

export default function FulfillmentModals({
    showDamageModal,
    setShowDamageModal,
    damageSubmitting,
    damageForm,
    setDamageForm,
    handleDamageSubmit,
    replacingItem,
    setReplacingItem,
    showScanReplaceModal,
    setShowScanReplaceModal,
    scannedReplaceId,
    setScannedReplaceId,
    scanningReplace,
    scanReplaceError,
    handleScanReplaceSubmit,
    showCancelModal,
    setShowCancelModal,
    cancelingOrder,
    confirmCancelOrder,
    damageTargetItem,
    copyOptions = [],
    copiesLoading = false
}) {
    return (
        <>
            {/* === DAMAGE LOG MODAL === */}
            {showDamageModal && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/45 px-4">
                    <div className="w-full max-w-md rounded-xl bg-white shadow-xl overflow-hidden p-6 relative text-left">
                        <button
                            type="button"
                            onClick={() => setShowDamageModal(false)}
                            className="absolute top-3 right-3 text-gray-400 hover:text-gray-600"
                        >
                            <XMarkIcon className="h-5 w-5" />
                        </button>
                        <h3 className="text-base font-bold text-gray-900 mb-1">Log Book Damage</h3>
                        {damageTargetItem && (
                            <p className="text-xs text-gray-500 mb-4 font-medium">
                                Book: <span className="font-semibold text-gray-800">{damageTargetItem.name || damageTargetItem.title || "Book"}</span>
                                <br />
                                Product ID: <span className="font-semibold text-gray-800">{damageTargetItem.product_id || "N/A"}</span>
                                {damageTargetItem.copy_post_id ? (
                                    <>
                                        <br />
                                        Copy Post ID: <span className="font-semibold text-gray-800">{damageTargetItem.copy_post_id}</span>
                                    </>
                                ) : null}
                            </p>
                        )}
                        <form onSubmit={handleDamageSubmit} className="space-y-4 text-xs">

                            <div>
                                <label className="block font-medium text-gray-700 mb-1">Reason</label>
                                <select
                                    value={damageForm.reason || ""}
                                    onChange={(e) => setDamageForm(prev => ({ ...prev, reason: e.target.value }))}
                                    className="w-full border border-gray-300 bg-white rounded px-3 py-2 outline-none focus:ring-1 focus:ring-black font-semibold text-gray-800"
                                >
                                    <option value="">Select Reason</option>
                                    <option value="Ripped Pages">Ripped Pages</option>
                                    <option value="Liquid Damage">Liquid Damage</option>
                                    <option value="Book Lost">Book Lost</option>
                                    <option value="Other Damages">Other Damages</option>
                                </select>
                            </div>

                            <div>
                                <label className="block font-medium text-gray-700 mb-1">Severity</label>
                                <select
                                    value={damageForm.severity || ""}
                                    onChange={(e) => setDamageForm(prev => ({ ...prev, severity: e.target.value }))}
                                    className="w-full border border-gray-300 bg-white rounded px-3 py-2 outline-none focus:ring-1 focus:ring-black font-semibold text-gray-800"
                                >
                                    <option value="">Select Severity</option>
                                    <option value="1">1</option>
                                    <option value="2">2</option>
                                    <option value="3">3</option>
                                    <option value="4">4</option>
                                </select>
                            </div>

                            <div>
                                <label className="block font-medium text-gray-700 mb-1 flex items-center gap-2">
                                    Copy ID
                                    {copiesLoading && <span className="text-[10px] text-gray-400 animate-pulse">(Loading...)</span>}
                                </label>
                                <select
                                    value={damageForm.copyId || ""}
                                    onChange={(e) => setDamageForm(prev => ({ ...prev, copyId: e.target.value }))}
                                    className="w-full border border-gray-300 bg-white rounded px-3 py-2 outline-none focus:ring-1 focus:ring-black font-semibold text-gray-800"
                                >
                                    {copyOptions.map((opt, idx) => (
                                        <option key={idx} value={opt.value}>
                                            {opt.label}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div>
                                <label className="block font-medium text-gray-700 mb-1">Damage Amount (₹)</label>
                                <input
                                    type="number"
                                    required={damageForm.reason !== "Other Damages"}
                                    value={damageForm.amt || ""}
                                    onChange={(e) => setDamageForm(prev => ({ ...prev, amt: e.target.value }))}
                                    placeholder="Enter damage fee"
                                    readOnly={damageForm.reason !== "Other Damages"}
                                    className="w-full border border-gray-300 rounded px-3 py-2 outline-none focus:ring-1 focus:ring-black font-semibold text-gray-800 read-only:bg-gray-50 read-only:text-gray-400 read-only:cursor-not-allowed"
                                />
                            </div>

                            <div>
                                <label className="block font-medium text-gray-700 mb-1">Remark / Notes</label>
                                <textarea
                                    value={damageForm.remark}
                                    onChange={(e) => setDamageForm(prev => ({ ...prev, remark: e.target.value }))}
                                    placeholder="Provide details about the damage..."
                                    className="w-full border border-gray-300 rounded px-3 py-2 outline-none focus:ring-1 focus:ring-black h-16 resize-none font-semibold text-gray-800"
                                />
                            </div>

                            <div className="flex items-center gap-2 pt-2">
                                <input
                                    type="checkbox"
                                    id="sendEmail"
                                    checked={damageForm.sendEmail}
                                    onChange={(e) => setDamageForm(prev => ({ ...prev, sendEmail: e.target.checked }))}
                                    className="rounded border-gray-350 focus:ring-black cursor-pointer"
                                />
                                <label htmlFor="sendEmail" className="text-gray-600 font-medium cursor-pointer">Send email notification to member</label>
                            </div>

                            <div className="flex items-center justify-end gap-3 pt-4 border-t border-gray-100">
                                <button
                                    type="button"
                                    onClick={() => setShowDamageModal(false)}
                                    className="px-4 py-2 border border-gray-200 rounded-md font-bold text-gray-700 hover:bg-gray-50 transition-colors"
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    disabled={damageSubmitting}
                                    className="px-4 py-2 bg-black text-white hover:bg-gray-800 rounded-md font-bold disabled:opacity-50 transition-colors"
                                >
                                    {damageSubmitting ? "Submitting..." : "Submit Damage"}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {/* === SCAN / REPLACE MODAL === */}
            {showScanReplaceModal && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/45 px-4">
                    <div className="w-full max-w-md rounded-xl bg-white shadow-xl overflow-hidden p-6 relative text-left">
                        <button
                            type="button"
                            onClick={() => {
                                setShowScanReplaceModal(false);
                                setReplacingItem(null);
                            }}
                            className="absolute top-3 right-3 text-gray-400 hover:text-gray-600"
                        >
                            <XMarkIcon className="h-5 w-5" />
                        </button>

                        <h3 className="text-base font-bold text-gray-900 mb-2">Scan / Replace Book</h3>
                        <p className="text-xs text-gray-500 mb-4 font-medium">
                            Replacing: <span className="font-semibold text-gray-800">{replacingItem?.name}</span> (ID: {replacingItem?.product_id})
                        </p>

                        <form onSubmit={handleScanReplaceSubmit} className="space-y-4 text-xs">
                            <div>
                                <label className="block font-medium text-gray-700 mb-1">Scanned Product / Copy ID</label>
                                <div className="flex gap-2">
                                    <input
                                        type="text"
                                        required
                                        value={scannedReplaceId}
                                        onChange={(e) => setScannedReplaceId(e.target.value)}
                                        placeholder="Type Product ID to replace..."
                                        className="flex-1 border border-gray-300 rounded px-3 py-2 outline-none focus:ring-1 focus:ring-black font-semibold text-gray-800"
                                        autoFocus
                                    />
                                    <button
                                        type="submit"
                                        disabled={scanningReplace || !scannedReplaceId.trim()}
                                        className="bg-black text-white hover:bg-gray-800 rounded px-4 py-2 font-bold disabled:opacity-50 transition-colors"
                                    >
                                        {scanningReplace ? "Searching..." : "Replace"}
                                    </button>
                                </div>
                                {scanReplaceError && (
                                    <p className="text-red-500 mt-1 font-semibold">{scanReplaceError}</p>
                                )}
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {/* === CANCEL ORDER CONFIRMATION MODAL === */}
            {showCancelModal && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/45 px-4">
                    <div
                        className="w-full max-w-md rounded-xl bg-white shadow-xl overflow-hidden p-6 relative text-left"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <button
                            type="button"
                            disabled={cancelingOrder}
                            onClick={() => setShowCancelModal(false)}
                            className="absolute top-3 right-3 text-gray-400 hover:text-gray-600 disabled:opacity-50"
                        >
                            <XMarkIcon className="h-5 w-5" />
                        </button>

                        <div className="flex items-start gap-4">
                            <div className="w-10 h-10 rounded-full bg-red-50 flex items-center justify-center flex-shrink-0">
                                <ExclamationTriangleIcon className="h-6 w-6 text-red-600" />
                            </div>
                            <div className="flex-1 min-w-0">
                                <h3 className="text-base font-bold text-gray-900 mb-2">Cancel Order</h3>
                                <p className="text-xs text-gray-500 leading-relaxed font-semibold">
                                    Are you sure you want to cancel this order?
                                    <br />
                                    This action cannot be undone and may initiate a refund process.
                                </p>
                            </div>
                        </div>

                        <div className="flex items-center justify-end gap-3 pt-6 mt-6 border-t border-gray-100">
                            <button
                                type="button"
                                disabled={cancelingOrder}
                                onClick={() => setShowCancelModal(false)}
                                className="px-4 py-2 border border-gray-200 rounded-md font-bold text-xs text-gray-700 hover:bg-gray-50 transition-colors disabled:opacity-50"
                            >
                                Keep Order
                            </button>
                            <button
                                type="button"
                                disabled={cancelingOrder}
                                onClick={confirmCancelOrder}
                                className="px-4 py-2 bg-red-600 text-white hover:bg-red-700 rounded-md font-bold text-xs transition-colors disabled:opacity-50 flex items-center gap-1.5"
                            >
                                {cancelingOrder && (
                                    <ArrowPathIcon className="h-3.5 w-3.5 animate-spin text-white" />
                                )}
                                {cancelingOrder ? "Canceling..." : "Cancel Order"}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}
